import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import FooterBottom from "./footerb";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="footer">
      <section>
        <Container>
          <Row
            className="footer-container mt-3 pt-4"
            style={{
              display: "flex",
            }}
          >
            <Col
              sm={12}
              md={6}
              lg={3}
              className="mb-3"
              style={{ margin: "0.5rem 3rem 0.5rem 0" }}
            >
              <div>
                <Link to={"/"}>
                  <img
                    src="/assets/logo.png"
                    className="img-fluid logo"
                    alt="logo"
                  />
                </Link>
              </div>
              <p className="mt-2">
                Empowering Enterprises with Cutting-Edge IT Products SERVING
                ENTERPRISES FOR 9+ YEARS
              </p>
              <div className="mt-5">
                <p>Get in touch</p>
                <div className="social-icons mt-3">
                  <a className="s-icon" href="">
                    <i className="fi fi-brands-facebook"></i>
                  </a>
                  <a
                    className="s-icon"
                    href="https://www.instagram.com/vnextitperipheralsolutions/"
                    target="_blank"
                  >
                    <i className="fi fi-brands-instagram"></i>
                  </a>
                  <a
                    className="s-icon"
                    href="https://x.com/VnextEnquiry?mx=2"
                    target="_blank"
                  >
                    <i className="fi fi-brands-twitter-alt-circle"></i>
                  </a>
                </div>
              </div>
            </Col>

            {/* <Col sm={12} md={6} lg={2} className="mb-3">
              <p className="txt-4">Our Products</p>
              <ul className="list-unstyled">
                <li>
                  <Link to="/product/smart-phone" className="txt-5">
                    Smart Phone
                  </Link>
                </li>
                <li>
                  <Link to="/product/watch" className="txt-5">
                    Smart watch
                  </Link>
                </li>
                <li>
                  <Link to="/product/tab" className="txt-5">
                    Tab
                  </Link>
                </li>
              </ul>
            </Col> */}

            <Col sm={12} md={6} lg={2} className="mb-3">
              <p className="txt-4">Quick Links</p>
              <ul className="list-unstyled">
                <li>
                  <Link to="/" className="text-decoration-none txt-5">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/product" className="text-decoration-none txt-5">
                    Product
                  </Link>
                </li>
                {/* <li>
                  <Link to="/offers" className="text-decoration-none txt-5">
                    Offers
                  </Link>
                </li> */}
              </ul>
            </Col>

            <Col sm={12} md={6} lg={3} className="mb-3">
              <p className="txt-4">Contact Us</p>
              <ul className="list-unstyled">
                <li>
                  <div className="d-flex gap-3">
                    <div>
                      <i className="fi fi-rs-marker"></i>
                    </div>
                    <div className="txt-5">
                      VNEXT IT Peripheral Solutions Private Limited Door No.59,
                      Flat No: 2B, Rajarathinam Apartment, 2nd Floor, T.T.K.
                      Road, Alwarpet, Chennai - 600 018.
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex gap-3">
                    <div>
                      <i className="fi fi-rs-envelope"></i>
                    </div>
                    <div className="txt-5">enquiry@vnextit.in</div>
                  </div>
                </li>
                <li>
                  <div className="d-flex gap-3">
                    <div>
                      <i className="fi fi-rr-phone-call"></i>
                    </div>
                    <div className="txt-5">+91 73059 40450</div>
                  </div>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
      <FooterBottom />
    </div>
  );
}
